var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgCharacterCat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "86px",
    height: "72px",
    viewBox: "0 0 86 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "img_character copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.89473474,0.505263158 C8.97590526,0.505263158 11.4736863,3.00304421 11.4736863,6.08420842 C11.4736863,9.11035742 9.06431524,11.5737657 6.05922845,11.6607795 L5.89473474,11.6631581 C2.81357053,11.6631581 0.315789474,9.16537832 0.315789474,6.08420842 C0.315789474,3.00304421 2.81357053,0.505263158 5.89473474,0.505263158 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB610\\uB798\\uBE44\\uAD50",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "img_character-copy",
    transform: "translate(-18.000000, -25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "img"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_cat_gray"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.65775,76.6279391 C64.2465,76.6279391 67.16025,72.6454391 67.16025,70.7966891 C67.16025,68.5541891 65.14275,67.2116891 60.65775,67.2116891 C56.17275,67.2116891 54.15525,68.5541891 54.15525,70.7966891 C54.15525,72.6454391 57.069,76.6279391 60.65775,76.6279391 Z",
    id: "Stroke-1",
    stroke: "#B0B5C1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.046875,58.3523141 C51.046875,59.7473141 49.918125,60.8723141 48.523125,60.8723141 C47.131875,60.8723141 46.003125,59.7473141 46.003125,58.3523141 C46.003125,56.9610641 47.131875,55.8323141 48.523125,55.8323141 C49.918125,55.8323141 51.046875,56.9610641 51.046875,58.3523141",
    id: "Fill-3",
    fill: "#B0B5C1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7935,60.8723141 C71.3985,60.8723141 70.26975,59.7473141 70.26975,58.3523141 C70.26975,56.9610641 71.3985,55.8323141 72.7935,55.8323141 C74.18475,55.8323141 75.3135,56.9610641 75.3135,58.3523141 C75.3135,59.7473141 74.18475,60.8723141 72.7935,60.8723141 Z",
    id: "Fill-5",
    fill: "#B0B5C1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0045,62.9978141 C96.0045,80.5140641 80.1795,95.9603141 60.657,95.9603141 C41.13825,95.9603141 25.3095,80.5140641 25.3095,62.9978141 C25.3095,45.4815641 41.13825,32.5253141 60.657,32.5253141 C80.1795,32.5253141 96.0045,45.4815641 96.0045,62.9978141 Z",
    id: "Stroke-7",
    stroke: "#B0B5C1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.244125,46.7636891 C25.316625,40.5349391 24.015375,33.2711891 25.316625,26.2661891 C32.580375,26.0074391 39.064125,28.8611891 44.775375,34.0511891",
    id: "Stroke-9",
    stroke: "#B0B5C1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.07175,46.7636891 C95.99925,40.5349391 97.3005,33.2711891 95.99925,26.2661891 C88.7355,26.0074391 82.25175,28.8611891 76.5405,34.0511891",
    id: "Stroke-11",
    stroke: "#B0B5C1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.37375,
    y1: 73.6159391,
    x2: 18.75,
    y2: 76.7396891,
    id: "Stroke-13",
    stroke: "#B0B5C1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.127125,
    y1: 81.5846891,
    x2: 22.919625,
    y2: 89.0846891,
    id: "Stroke-15",
    stroke: "#B0B5C1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.942125,
    y1: 73.6159391,
    x2: 102.565875,
    y2: 76.7396891,
    id: "Stroke-17",
    stroke: "#B0B5C1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.188375,
    y1: 81.5846891,
    x2: 98.395875,
    y2: 89.0846891,
    id: "Stroke-19",
    stroke: "#B0B5C1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.564,82.2529391 C64.40775,83.8166891 60.65775,80.6891891 60.65775,76.6279391 C60.65775,80.6891891 56.90775,83.8166891 51.7515,82.2529391",
    id: "Stroke-21",
    stroke: "#B0B5C1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(60.000000, 58.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgCharacterCat);
export default __webpack_public_path__ + "static/media/img_character_cat.8554bfbc.svg";
export { ForwardRef as ReactComponent };